import React from "react"
import humanFileSize from "../../../helpers/human_file_size"
import AccessDates from "../../Common/access_dates"
import SharedTable from "../../Common/table"

const Uploads = ({ match }) =>
  <SharedTable
    collection={"uploads"}
    queries={{ video_id: match.params.videoID }}
    disableRowClick={true}
    isCompact={true}
    tableKeys={[
      { text: "Method", key: "upload_method" },
      { text: "File", key: "file_name" },
      { text: "Status", key: "status" },
      { text: "Updated", key: "updated_at" }
    ]}
    tableWidths={[90, "auto", 220, 220]}
    tableValues={[
      upload => upload.upload_method,
      upload => upload.file_name,
      upload =>
        <div>
          {upload.status}
          <span className='block light small'>
            {humanFileSize(upload.current_size)} of {" "}
            {humanFileSize(upload.total_size)}
          </span>
        </div>,
      upload => <AccessDates model={upload}/>
    ]}/>

export default Uploads
